import { useEffect } from "react";
import Select, { components, DropdownIndicatorProps } from 'react-select';
import { getFacilityDropdown } from "../../Redux/user/action";
import { useState } from "react";
import { HiChevronDown } from 'react-icons/hi';
import { TbGridDots } from 'react-icons/tb';


const FacilityMultiSelectSelect = ({ facility, options, handleChange,clients,setFacilities,setSelectedFacility,formik ,isSingle=false, menuPortalTarget}) => {
	const DropdownIndicator = ({ state, ...props }) => {
			return <components.DropdownIndicator {...props}>{facility?.length > 1 ? <TbGridDots style={{ fontSize: "1.5em" }} /> : <HiChevronDown style={{ fontSize: "1.5em" }} />}</components.DropdownIndicator>;
	};
	const [isFocus, setIsFocus] = useState(false);

	useEffect(() => {
        if (clients && clients.length > 0) {
            getFacilityDropdown(clients)((response) => {
                if (response && response.status) {
					const selectedFacilitiesIds = response.data.facilities.flatMap(i=>i.facilities)?.map(ite=>ite.value)
					const filterFacility = facility?.filter(i => selectedFacilitiesIds.includes(i.value))
					setSelectedFacility(filterFacility);                    
					formik.setFieldValue("facility", filterFacility?.map((i)=>i.value))
					setFacilities(
                        response.data.facilities?.map((result) => {
                        	return { options: result?.facilities, label: result?.client };
                        })
                    );
                }
            });
    	}
        }, [clients]);
        return (
                <Select
                        className="basic-single"
                        classNamePrefix="select"
                        isMulti
                        tabSelectsValue={false}
                        closeMenuOnSelect={isSingle}
                        menuPortalTarget={menuPortalTarget}
                        value={facility}
                        name="facility"
                        options={options}
                        components={{ DropdownIndicator: (props) => <DropdownIndicator {...props} state="facility" /> }}
                        onChange={(e)=>handleChange(e,'facility')}
                        placeholder="Select Facility"
                        onFocus={() => setIsFocus(true)}
                        onBlur={() => setIsFocus(false)}
                        styles={{
                                container: (styles, state) => ({
                                        ...styles,
                                        borderRadius: "9px",
                                        width:"100%"
                                      
                                }),
                                control: (styles, state) => ({
                                        ...styles,
                                        backgroundColor: "hsl(204deg 33.33% 97.06%)",
                                        borderStyle: "none",
                                        boxShadow: "none",
                                        borderRadius: "10px",
                                        maxHeight: isFocus ? "auto" : "30px",
                                }),
                                
                                menuPortal: (styles) => ({ ...styles, zIndex: 9999 }),
                                indicatorSeparator: (styles) => ({
                                        ...styles,
                                        width: "0px",
                                        minHeight: "20px",
                                }),

                                valueContainer: (styles, state) => ({
                                        ...styles,
                                        maxHeight: isFocus ? "auto" : "30px",
                                }),
                               
                        }
                }
                />
        );
};
export default FacilityMultiSelectSelect;
